import styled from 'styled-components';

export const CurrentPageWrapper = styled.div`
  margin-top: 70px;
  margin-left: 0.9rem;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;
